import React from 'react'
import styled, { css } from 'styled-components'

import { Button } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { Drawer, FadeOverflow } from '@root/shared/ui-kit'

import { PremiumInfo } from '../common/premium-info'
import { ScreenGlowing } from '../common/screen-glowing'

import type { PremiumMeta } from '@root/entities/premium'
import type { DrawerControlProps } from '@root/shared/ui-kit'

type Props = DrawerControlProps & {
  product: PremiumMeta.PremiumProduct
  withScroll?: boolean
}

export const PremiumInfoDrawer: React.FC<Props> = ({
  open,
  onOpenChange,
  product,
}) => {
  const { t } = useTranslation()

  return (
    <Root
      open={open}
      onOpenChange={onOpenChange}
      $color={
        product === 'subscription'
          ? 'var(--subscriptionGlow-9)'
          : 'var(--boostGlow-9)'
      }
    >
      <Content>
        <ScreenGlowing product={product} />
        <FadeOverflow
          variant="vertical"
          mode="always"
          css={css`
            overflow: auto;
            max-height: 100%;
          `}
        >
          <PremiumInfo product={product} />
        </FadeOverflow>
        <ButtonClose
          radius="rounded"
          onClick={() => onOpenChange?.(false)}
          fullWidth
          color="primary"
          size="m"
        >
          {t('premium.info.button.check-token')}
        </ButtonClose>
      </Content>
    </Root>
  )
}

const Root = styled(Drawer)<{ $color: string }>`
  background-color: var(--background-1);
  background-image: radial-gradient(
    55% 130px at 50% -5%,
    ${(props) => props.$color} 30%,
    transparent 100%
  );
  height: var(--max-drawer-height);
`

const Content = styled.div`
  overflow: hidden;

  display: grid;
  grid-template-rows: minmax(0, 1fr) auto;
  align-items: start;
  min-height: 0;

  padding-block: 0 var(--safe-bottom);
  padding-inline: 12px;
`

const ButtonClose = styled(Button)`
  position: relative;
  z-index: 1;
`
